import React from "react";

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  key?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  value?: any;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: boolean;
  helperText?: string;
  rows?: number;
  required?: boolean;
  optional?: boolean;
}

const Textarea: React.FC<TextareaProps> = ({
  key = "",
  label,
  name,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  rows = 4,
  required = false,
  optional = false,
}) => {
  return (
    <div key={key} className="flex flex-col items-start space-y-1">
      {label && (
        <label className="text-sm font-medium text-gray-700">
          {label} {optional && <span>(optional)</span>}{" "}
          {required && <span className="text-red-600">*</span>}
        </label>
      )}

      <textarea
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="w-full border border-gray-300 rounded-lg p-3 h-32 focus:ring-2 focus:ring-indigo-500 outline-none placeholder:text-sm text-sm"
        rows={rows}
      />

      {helperText && (
        <span className={`text-xs ${error ? "text-red-500" : "text-gray-500"}`}>
          {helperText}
        </span>
      )}
    </div>
  );
};

export default Textarea;
